<!-- eslint-disable -->
<template lang="pug">
    .examples-viewer
        .examples-viewer__examples
            .example(v-for="(example, index) in data")
                .example__container(:style="exampleStyle(index)")
                    .example__title
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_answer') }} {{ index + 1 }}
                    .example__actions
                        .example__action
                            div(
                                v-for="word in example"
                                :class="word.selectedItem"
                                :style="getStyle(word)"
                            )  {{ word.word }}
        .examples-viewer__button
            cs-button(
                color="blue"
                @click="$router.push({name: 'dashboard'})"
            )
                | {{ $i18n.t('common.common_navigation_goToMain') }}
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            examplesArray: Array,
            possibleAnswers: Array,
        },
        data () {
            return {
                colors: [
                    'hsl(121, 58%, 58%)', 'hsl(212, 100%, 56%)', 'hsl(15, 100%, 64%)', 'hsl(38, 100%, 56%)',
                    'hsl(331, 100%, 68%)', 'hsl(158, 62%, 54%)', 'hsl(284, 59%, 64%)', 'hsl(195, 86%, 64%)'
                ],
            }
        },
        methods: {
            exampleStyle(index) {
                return { color: this.colors[index % this.colors.length] };
            },
            getStyle(word) {
                if (!word.isNonWordItem) {
                    return {
                        'margin-left': '15px',
                    }
                }
            },
        },
        computed: {
            data() {
                let arr = [];
                this.examplesArray.forEach(item => {
                    let tempArr = item.example.split(' ').map(word => {
                        let neededItem = null;
                        this.possibleAnswers.forEach(string => {
                            let valuesArray = item[string].split(',').map(word => word.trim());
                            if (valuesArray.includes(word.toLowerCase())) {
                                neededItem = string;
                            }
                        })
                        return {
                            word,
                            selectedItem: neededItem,
                            isNonWordItem: /[^\wа-яё]/iu.test(word),
                        };
                    })
                    arr.push(tempArr);
                })
                return arr;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .examples-viewer {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .examples-viewer__examples {
        display: flex;
        margin: -10px -10px 0;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: center;
        text-align: center;
        font-size: $font-size-24;
    }

    .example {
        padding: 10px;
    }

    .example__elements {
        display: flex;
    }

    .example__action {
        display: flex;
        flex-wrap: wrap;
    }

    .example__action:nth-child(2n) {
        filter: hue-rotate(10deg) saturate(50%);
    }

    .example__container {
        background-color: $x-color-white;
        padding: 10px;
        border: 1px solid;
        border-radius: $border-radius-10;
    }

    .example__title, .example__answer {
        @include stack-space($space-x-small);
        margin-top: 10px;
    }

    .examples-viewer__button {
        margin-top: 20px;
    }

    .subject {
        background: url("../../../../assets/images/sentence-parsing/subject.png") repeat-x center 25px;
    }

    .predicate {
        background: url("../../../../assets/images/sentence-parsing/predicate.png") repeat-x center 25px;
    }

    .definition {
        background: url("../../../../assets/images/sentence-parsing/definition.png") repeat-x center 25px;
    }

    .complement {
        background: url("../../../../assets/images/sentence-parsing/complement.png") repeat-x center 25px;
    }

    .circumstance {
        background: url("../../../../assets/images/sentence-parsing/circumstance.png") repeat-x center 25px;
    }
</style>
